module.exports = __webpack_public_path__ + "static/media/caseInfoBtnEng.bbcf833f.png";